import Settings from '../olr-common/Settings';

export default function SubjectService($http) {
  let url = Settings.backendEnv + "/api/v1/subject";

  this.saveSubject = function(subjectObj) {
    var req = {
      method: subjectObj.subjectId ? "PUT" : "POST",
      url:    subjectObj.subjectId ? url + "/" + subjectObj.subjectId : url,
      data:   subjectObj
    };

    return $http(req);
  };

  this.deleteSubject = function(subjectObj) {
    console.log(subjectObj);
    var req = {
      method: "DELETE",
      url:    url + "/" + subjectObj.subjectId
    };

    return $http(req);
  };

  this.getAllSubjects = function(){
    return $http({method: 'GET',url: url});
  };
}

export function SubjectServiceStub($httpBackend, localStorageService) {
  $httpBackend
    .whenPOST('/mainv1/api/subject')
    .respond(function(method, url, data) {
      let timestamp = new Date().getUTCMilliseconds();
      return [200, {subjectId:timestamp}, {/* response header */}];
  });

  $httpBackend
    .whenGET('/mainv1/api/subject')
    .respond(function(method, url, data) {
      var subjects = localStorageService.get('subjects');
      return [200, subjects, {/* response header */}];
    });

  $httpBackend
    .whenPUT(/.*?mainv1\/api\/subject?.*/g)
    .respond(function(method, url, data) {
      return [200, {subject: 'updated'}, {/* response header */}];
    });

  $httpBackend
    .whenDELETE(/.*?mainv1\/api\/subject?.*/g)
    .respond(function(method, url, data) {
      return [200, {}, {/* response header */}];
    });
}




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/SubjectService.js
 **/